import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AnalysisMetric;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import { getSanitizedMetricValue } from '../../common/utils';
import { Metric } from '@instructure/ui-metric';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var AnalysisMetric = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_AnalysisMetric = /*#__PURE__*/function (_Component) {
  function AnalysisMetric() {
    _classCallCheck(this, AnalysisMetric);
    return _callSuper(this, AnalysisMetric, arguments);
  }
  _inherits(AnalysisMetric, _Component);
  return _createClass(AnalysisMetric, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        metricKey = _this$props.metricKey,
        label = _this$props.label,
        value = _this$props.value,
        suffix = _this$props.suffix;
      var dataAutomation = "sdk-new-ia-quiz-analysis-".concat(metricKey);
      return jsx("div", {
        "data-automation": dataAutomation,
        css: this.props.styles.metricWrapper
      }, jsx(Metric, {
        themeOverride: {
          valueFontWeight: 500,
          padding: '0'
        },
        textAlign: "start",
        key: metricKey,
        renderLabel: jsx("p", {
          css: this.props.styles.metricLabel
        }, label),
        renderValue: getSanitizedMetricValue(value, suffix)
      }));
    }
  }]);
}(Component), _defineProperty(_AnalysisMetric, "displayName", 'AnalysisMetric'), _defineProperty(_AnalysisMetric, "componentId", "Quizzes".concat(_AnalysisMetric.displayName)), _defineProperty(_AnalysisMetric, "propTypes", {
  metricKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  suffix: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_AnalysisMetric, "defaultProps", {
  value: void 0,
  suffix: ''
}), _AnalysisMetric)) || _class);